<template>
  <div>
    <div class="list-group small">
      <button class="list-group-item list-group-item-action" v-for="field in orderable" :key="field.key" @click="fieldClicked(field)">
        <div class="d-flex align-items-center g-3">
          <CheckboxView :active="selected === field.key" color="primary" round/>
          {{ field.name }}
        </div>
      </button>
    </div>
    <div v-if="selected" class="card mt-3">
      <div class="py-3 px-4">
        <div class="d-flex align-items-center justify-content-around">
          <button style="background: transparent; border: none; font-size: 1em" class="clickable p-3 m-n3" :class="direction === 'asc' ? 'text-primary' : 'text-foreground'" @click="direction !== 'asc' ? emit('update:direction', 'asc') : undefined">
            <i class="fa-duotone fa-arrow-up-wide-short" style="font-size: 1.4em"></i>
          </button>
          <button style="background: transparent; border: none; font-size: 1em" class="clickable p-3 m-n3" :class="direction === 'desc' ? 'text-primary' : 'text-foreground'" @click="direction !== 'desc' ? emit('update:direction', 'desc') : undefined">
            <i class="fa-duotone fa-arrow-down-wide-short" style="font-size: 1.4em"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CheckboxView from "../forms/inputs/CheckboxView.vue";

const props = defineProps({
  orderable: Array,
  selected: String,
  direction: String
});

const emit = defineEmits(["update:selected", "update:direction"]);

function fieldClicked(field) {
  if (props.selected === field.key) {
    emit('update:selected', undefined);
  } else {
    emit('update:selected', field.key);
    if (!props.direction) {
      emit('update:direction', "asc");
    }
  }
}
</script>